import { type ButtonHTMLAttributes, forwardRef, type Ref } from 'react';
import { StyledButton } from './FormButton.styles';
import ButtonSpinner from './ButtonSpinner/ButtonSpinner';
import { type FormButtonVariant } from './types';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'ref'> {
  variant: FormButtonVariant;
  isLoading?: boolean;
}

const FormButton = forwardRef(
  (
    { isLoading, disabled, children, variant, ...rest }: ButtonProps,
    ref?: Ref<HTMLButtonElement>
  ) => {
    return (
      <StyledButton
        as="button"
        ref={ref}
        disabled={isLoading || disabled}
        variant={variant}
        {...rest}
      >
        {children}
        {isLoading && <ButtonSpinner variant={variant} />}
      </StyledButton>
    );
  }
);

export default FormButton;
